import { useState } from 'react';
import Overlay from '@alifd/next/lib/overlay';
import { AiAssistant } from './AiAssistant';

export function AssistantOverlay(props: any) {
  const [visible, setVisible] = useState<boolean>(false);
  const [dialogVisible, setDialogVisible] = useState<boolean>(false);

  const onVisibleChange = (evt: any) => {
    setVisible(evt);
  };

  const handleSelectOK = (colleague: any) => {
    setVisible(false);
    props.onOk?.(colleague);
  };

  const onDialogChanged = (dialogVisible: boolean) => {
    setDialogVisible(dialogVisible);
  };

  return (
    <>
      <Overlay.Popup
        v2
        triggerType="click"
        placement="r"
        trigger={
          <a
            className="J_menuItem"
            onClick={() => {
              setVisible(!visible);
            }}
          >
            <i className="bef-ai-i">
              <svg
                viewBox="0 0 1024 1024"
                width="1em"
                height="1em"
                fill="currentColor"
              >
                <path d="M269.69088 302.45888c0 37.81632 30.65856 68.46464 68.46464 68.46464s68.46464-30.64832 68.46464-68.46464c0-37.80608-30.65856-68.46464-68.46464-68.46464s-68.46464 30.65856-68.46464 68.46464zM899.54304 1.21856H123.63776c-20.19328 0-36.51584 16.32256-36.51584 36.51584v753.09056c0 20.19328 16.32256 36.5056 36.51584 36.5056h775.90528c20.19328 0 36.5056-16.31232 36.5056-36.5056V37.7344c0.01024-20.19328-16.30208-36.51584-36.5056-36.51584zM863.0272 754.30912H160.14336V74.25024H863.0272v680.05888zM616.56064 302.45888c0 37.81632 30.65856 68.46464 68.46464 68.46464 37.81632 0 68.46464-30.64832 68.46464-68.46464 0-37.80608-30.64832-68.46464-68.46464-68.46464-37.80608 0-68.46464 30.65856-68.46464 68.46464z m285.4912 634.4192H121.12896c-18.82112 0-34.00704 16.32256-34.00704 36.51584v41.07264c0 5.02784 3.76832 9.13408 8.448 9.13408h831.92832c4.67968 0 8.448-4.10624 8.448-9.13408v-41.07264c0.11264-20.20352-15.06304-36.51584-33.8944-36.51584zM685.02528 507.84256H338.15552c-5.0176 0-9.12384 4.10624-9.12384 9.13408v68.46464c0 5.0176 4.10624 9.12384 9.12384 9.12384h346.88c5.0176 0 9.13408-4.10624 9.13408-9.12384v-68.46464c-0.01024-5.02784-4.11648-9.13408-9.14432-9.13408z m0 0" />
              </svg>
            </i>
            <span className="bef-menu-label">AI助理</span>
          </a>
        }
        visible={visible}
        onVisibleChange={onVisibleChange}
        canCloseByOutSideClick={!dialogVisible}
        canCloseByEsc={!dialogVisible}
      >
        <div
          style={{ paddingLeft: '25px', width: '772px', height: '90%' }}
          className="custom-left-menu"
        >
          <AiAssistant
            onOK={handleSelectOK}
            onDialogChanged={onDialogChanged}
            onClose={() => setVisible(false)}
          ></AiAssistant>
        </div>
      </Overlay.Popup>
    </>
  );
}
